import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { authFetchBaseQuery, baseUrl, CLOUD_FETCH_TIMEOUT } from './apiConfig';
import { ResponseBase } from './request';

const baseEndpointUrl = `${baseUrl}`;
const apiPrefix = 'status';

export interface ApiStatus {
  createdAt: string;
  createdBy: string;
  id: number;
  name: string;
  status: number;
  updatedAt: string;
}

interface ApiStatusResponse extends ResponseBase {
  data: ApiStatus;
}

export const statusApi = createApi({
  reducerPath: 'statusApi',
  baseQuery: authFetchBaseQuery({
    baseUrl: baseEndpointUrl,
  }),
  endpoints: (builder) => ({
    getApiStatus: builder.query<ApiStatus, void>({
      query: () => ({ url: `${apiPrefix}`, timeout: CLOUD_FETCH_TIMEOUT }),
      transformResponse: (response: ApiStatusResponse) => response.data,
    }),
  }),
});

export const { useGetApiStatusQuery } = statusApi;
